import React, { useEffect } from 'react';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    XAxis,
    YAxis,
    LabelList,
} from 'recharts';
import './styles.css';
import { useTranslation } from '../../i18n';

interface DataCategories {
    Hierarchy: number | undefined;
    Market: number | undefined;
    Adhocracy: number | undefined;
    Family: number | undefined;
}
interface DataItem extends DataCategories {
    name: string;
}

interface WorkPreferenceBarChartProps {
    data: DataItem[];
}
const WorkPreferenceBarChart = (props: WorkPreferenceBarChartProps) => {
    const { data } = props;
    const { t } = useTranslation();

    useEffect(() => {
        const fields: (keyof DataCategories)[] = [
            'Hierarchy',
            'Market',
            'Adhocracy',
            'Family',
        ];
        data.forEach((item) => {
            fields.forEach((field) => {
                if (item[field] === 0) {
                    item[field] = undefined;
                }
            });
        });
    }, []);

    return (
        <div className="workPreferencesBarChart">
            <ResponsiveContainer width="99%" height="100%">
                <BarChart
                    data={data}
                    margin={{
                        top: 10,
                        right: 5,
                        left: 5,
                        bottom: 0,
                    }}
                    maxBarSize={150}>
                    <CartesianGrid vertical={false} strokeDasharray="0" />
                    <XAxis
                        type="category"
                        dataKey="name"
                        minTickGap={25}
                        fontSize={14}
                        dy={8}
                    />
                    <YAxis
                        type="number"
                        domain={[0, 100]}
                        axisLine={false}
                        tickCount={5}
                        unit="%"
                        tickLine={false}
                        fontSize={14}
                    />
                    <Bar dataKey="Family" stackId="a" fill="#1AA277" unit="%">
                        <LabelList
                            dataKey="Family"
                            position="insideTop"
                            style={{ fill: '#ffffff', fontSize: 14 }}
                        />
                    </Bar>
                    <Bar
                        dataKey="Adhocracy"
                        stackId="a"
                        fill="#33B7BD"
                        unit="%">
                        <LabelList
                            dataKey="Adhocracy"
                            position="insideTop"
                            style={{ fill: '#ffffff', fontSize: 14 }}
                        />
                    </Bar>
                    <Bar dataKey="Market" stackId="a" fill="#4A62AD" unit="%">
                        <LabelList
                            dataKey="Market"
                            position="insideTop"
                            style={{ fill: '#ffffff', fontSize: 14 }}
                        />
                    </Bar>
                    <Bar
                        dataKey="Hierarchy"
                        stackId="a"
                        fill="#AE509D"
                        unit="%">
                        <LabelList
                            dataKey="Hierarchy"
                            position="insideTop"
                            style={{ fill: '#ffffff', fontSize: 14 }}
                        />
                    </Bar>
                    <Legend
                        layout="vertical"
                        verticalAlign="top"
                        align="right"
                        wrapperStyle={{ marginTop: '50px', fontSize: 14 }}
                        formatter={(value: string) => {
                            return t(
                                `CULTURAL_FIT.WORK_PREFERENCES.CATEGORIES.${value.toUpperCase()}`,
                            );
                        }}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default WorkPreferenceBarChart;
